// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

export var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

export var getBatch = function getBatch() {
  return batch;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/es/utils/batch.js
// module id = ZnSB
// module chunks = 0